const BASE_API = process.env.MIX_ENDLESS_API_URL
const BASE_APP = process.env.MIX_ENDLESS_APP_URL

const state ={
	places:[],
	courseLanguages:[],
	schoolTypes:[],
	courseSubjects:[],
	learningMethods:[],
	testTypes:[],
	searchData:[],
}
const getters = {
	placesGetter:({places}) => places,
	courseLanguagesGetter:({courseLanguages}) => courseLanguages,
	schoolTypesGetter : ({schoolTypes}) => schoolTypes,
	courseSubjectsGetter : ({courseSubjects}) => courseSubjects,
	learningMethodsGetter:({learningMethods}) => learningMethods,
	testTypesGetter:({testTypes}) => testTypes,
	searchDataGetter:({searchData}) => searchData,
}

const mutations = {
	setPlaces : (state,payload) => state.places = payload,
	setCourseLanguages: (state, payload) => state.courseLanguages = payload,
	setSchoolTypes:(state,payload) => state.schoolTypes = payload,
	setCourseSubjects:(state,payload) => state.courseSubjects = payload,
	setLearningMethods:(state,payload) => state.learningMethods = payload,
	setTestTypes:(state,payload) => state.testTypes = payload,
	setSearchData:(state,payload) => state.searchData = payload,
}

const actions = {
	async getPlaces({commit},payload){
		if(payload.headers['accept-school-type']) {
			this.$axios.defaults.headers['Accept-School-Type'] = payload.headers['accept-school-type']
		}
		await this.$axios.get(`${BASE_API}/places`,{params:{...payload.params}}).then(res => {
			commit('setPlaces',res.data.result.data)
		})
	},
	async getCourseLanguages({commit}){
		await this.$axios.get(`${BASE_API}/course-languages`).then(res => {
			commit('setCourseLanguages',res.data.result.data)
		})
	},
	async getSearchData({commit}, payload) {
		let language = null;
		if (language === null) {
			language = JSON.parse(document.getElementsByName('current_language')[0].getAttribute('content'));
		}

		if (language && language.language == 'tr') {
			language = null;
		}

		// URL'den mevcut path'i al ve kontrol et
		const currentPath = window.location.pathname;
		const languagePrefix = language ? language.language + '/' : '';
		
		// Eğer URL zaten dil prefix'i içeriyorsa, tekrar ekleme
		const searchPath = currentPath.includes(`/${language?.language}/`) 
			? 'search/autocomplete' 
			: `${languagePrefix}search/autocomplete`;

		await this.$axios.get(`${searchPath}?query=${payload.search}`).then(res => {
			commit('setSearchData', res.data.result.data)
		});
	},
	async getSchoolTypes({commit},payload){
		await this.$axios.get(`${BASE_API}/course-types`,{headers:{...payload.headers}}).then(res => {
			commit('setSchoolTypes',res.data.result.data)
		})
	},
	async getCourseSubjects({commit}){
		await this.$axios.get(`${BASE_API}/course-subjects`).then(res => {
			commit('setCourseSubjects',res.data.result.data)
		})
	},
	async getLearningMethods({commit}){
		await this.$axios.get(`${BASE_API}/learning-methods`).then(res => {
			commit('setLearningMethods',res.data.result.data)
		})
	},
	async getTestTypes({commit}){
		await this.$axios.get(`${BASE_API}/test-types`).then(res => {
			commit('setTestTypes',res.data.result.data)
		})
	}
}

export default {namespaced:true,state,getters,mutations,actions}
